import { gql } from '@apollo/client'

export const ROOM_CHAIR_QUERY = gql`
  query RoomChairQuery {
    roomLayout {
      id
    }
  }
`
